import { marketingUrls, DEFAULT_MARKETING_URL } from "@reciperoll/core";

// Policy/support links for the web app, with the marketing base taken from the
// build environment (VITE_MARKETING_URL) so the domain isn't hard-coded. Falls
// back to the live domain when unset. Auth redirects aren't here — the web app
// derives those from window.location.origin.
export const POLICY_URLS = marketingUrls(
  (import.meta.env.VITE_MARKETING_URL as string | undefined) ?? DEFAULT_MARKETING_URL,
);
